export default "__VITE_ASSET__BibyAdpv__"